import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { debounce as _debounce } from 'underscore';


export default class{

    constructor( options ) {
        this.defaults = {
            $el    :    [],
        }
        this.options = {};
        Object.assign(this.options, this.defaults, options);
        this.namespace      =   'draggable_module';
        this.$el            =   this.options.$el;
        this.main           =   this.options.main;

        if ( this.$el.length > 0 ){
            this.init();
        }
    }

    init(){
        this.$html      = $('html');
        this.$win       = $(window);


        
        this.$draggable     =   this.$el.find( '.draggable-content' );

        //this.$inner         = this.$draggable.find( '.inner' );
        this.addEvents( true );

        this.update();

        this.$el.addClass( 'ready' );

        
    }

    //---------------------------------------- EVENTS ---------------------------------------//
    addEvents( b ){
        if ( b ){

            // set draggable
            Draggable.create( this.$draggable, {
                type:"x",
                bounds: this.$el,
                // THIS NEED INIERTIA PLUGIN!!!!!!!!!
                inertia: true     
            });

            this.draggableInstance = Draggable.get( this.$draggable );
        }
        else{

            this.draggableInstance.kill();

        }
        this.debounceResize(b);
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        this.update();
    }

    update(){


        this.$draggable.css({
            width: 'max-content'
        });


        this.width = Math.ceil( this.$draggable.width() );

        if ( this.$el.width() < this.width ){
            this.$el.addClass( 'active' );
            this.draggableInstance.enable();
        }
        else{

            this.$draggable.css({
                width: '100%'
            });


            this.$el.removeClass( 'active' );
            this.draggableInstance.disable();
            gsap.set( this.$draggable, {x: 0 } );
           
        }
    }

    destroy(){
        this.addEvents( false );
    }

}


